import React, { createElement } from 'react';
import PropTypes from 'prop-types';

import './LinkIconPreview.css';

const LinkIconPreview = ({
  className,
  onClick,
  activeIcon,
  iconSize,
  iconStroke,
  iconColor,
}) => {

  return (
    <div
      className={`icon-preview__component ${className}`}
      onClick={onClick}
    >
      {createElement(activeIcon.icon, {
        size: iconSize,
        strokeWidth: iconStroke,
        color: iconColor,
      })}
      <div className="icon-name">{activeIcon.name}</div>
    </div>
  );
};

LinkIconPreview.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  activeIcon: PropTypes.object,
  iconSize: PropTypes.number,
  iconStroke: PropTypes.number,
  iconColor: PropTypes.string,
  ref: PropTypes.object,
};
LinkIconPreview.defaultProps = {
  className: '',
  onClick: null,
  activeIcon: null,
  iconSize: 32,
  iconStroke: 2,
  iconColor: '#000000',
  ref: null,
};

export default LinkIconPreview;
